/**
 * Defines a bullet list
 *
 * <gw-bullet-list>
 *   <gw-bullet-list-item>Na-na</gw-bullet-list-item>
 *   <gw-bullet-list-item>Na-na</gw-bullet-list-item>
 *   <gw-bullet-list-item>Batman!</gw-bullet-list-item>
 * </gw-bullet-list>
 */
define(
    ['text!./templates/BulletList.html', './LayoutFactory'],
    (template, layout) => layout('BulletList', template, partial => {
        partial('Item');
    })
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/layouts/BulletList.js